export const environment = {
  production: true,
  authorization: {
    authority: '#{auth_api_url}#',
    clientId: 'inspection-components-harness',
    clientScope: 'inspection-components user-preferences nexus flip auction-recon auction-vehicle-location adesa-share-component',
    silentRedirectUri: '/callback',
  },
};
